import { Button, Group, Stack, Text, Title } from '@mantine/core';
import { modals } from '@mantine/modals';

import { EnvironmentCountries, TransitGuarantee } from '@e-origin/shared';

import { deleteIcon } from '@assets';
import { useSettings } from '@hooks/useSettings';
import { TransitGuaranteeData } from './TransitGuaranteeData';
import { transitGuaranteesModalManager } from './transitGuaranteesModalManager';

interface TransitGuaranteeViewProps {
  guarantee: TransitGuarantee;
  onUpdateAccessCode: () => void;
  onDelete: () => void;
  onSave: (values: TransitGuarantee) => void;
}

export const TransitGuaranteeView: React.FC<TransitGuaranteeViewProps> = ({ guarantee, onUpdateAccessCode, onDelete, onSave }) => {
  const { data: settings } = useSettings();

  const sendAccessCode = () => {
    modals.openConfirmModal({
      title: 'Confirm send new access code',
      children: (
        <Stack>
          <Text>Are you sure you want to send the new access code?</Text>
          <Text>The customer data will be saved first.</Text>
        </Stack>
      ),
      labels: { confirm: 'Yes', cancel: 'No' },
      onConfirm: onUpdateAccessCode,
    });
  };

  const updateAccessCode = () => {
    transitGuaranteesModalManager.openEditAccessData(guarantee, onSave);
  };

  const deleteGuarantee = () => {
    modals.openConfirmModal({
      title: 'Confirm delete',
      children: 'Are you sure you want to delete this guarantee?',
      labels: { confirm: 'Yes', cancel: 'No' },
      onConfirm: onDelete,
    });
  };

  return (
    <Stack px="sm">
      <Group justify="space-between">
        <Title order={6} fw={500}>
          Guarantee
        </Title>
        <Group gap={0}>
          {settings?.country === EnvironmentCountries.NL && (
            <>
              <Button type="button" onClick={updateAccessCode} size="compact-sm">
                Update access code
              </Button>
              <Button ml="xl" size="compact-sm" onClick={sendAccessCode} disabled={!guarantee.masterAccessCode}>
                Send access code
              </Button>
              <Button type="button" onClick={deleteGuarantee} variant="transparent">
                <img src={deleteIcon} alt="Delete" />
              </Button>
            </>
          )}
        </Group>
      </Group>
      <TransitGuaranteeData guarantee={guarantee} onSave={onSave} />
    </Stack>
  );
};
